import React from 'react';
import PropTypes from 'prop-types';
import './ChoiceButton.css';

const ChoiceButton = ({
  selected = false,
  className = '',
  children,
  ...props
}) => {
  const classes = [
    'choice-button',
    selected ? 'choice-button--selected' : 'choice-button--default',
    className
  ].filter(Boolean).join(' ');

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

ChoiceButton.propTypes = {
  selected: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default ChoiceButton;

